import React from 'react'
import Link from 'next/link'
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getServiceBannersList } from '../../redux/slices/common'
import { pathNameServiceTypeMapping } from '../../utils/serviceTypes'
import { Skeleton, Box, Typography, Grid, Stack } from '@mui/material'

const VideoBanner = ({ router, pageName }) => {
  const capitalizedPageName = pageName
    ? pageName.charAt(0).toUpperCase() + pageName.slice(1)
    : ''

  const dispatch = useDispatch()
  const videoRef = useRef(null)
  const [data, setData] = useState([])
  const currentTab = capitalizedPageName
  const [bannerLocalImage, setBannerLocalImage] = useState(
    JSON.parse(localStorage.getItem('bannerImageVideo')) || {}
  )
  const [backgroundImages, setBackgroundImages] = useState(null)
  const [isVideo, setIsVideo] = useState(false)
  const { serviceBannerVideoList } = useSelector(state => state.common)
  const [isVideoDisabled, setIsVideoDisabled] = useState(false)
  const [loader, setLoader] = useState(true)
  const [backgroundImagesTitle, setBackgroundImagesTitle] = useState(null)

  useEffect(() => {
    // const isFlightOrHotels = pageName === 'flights' || pageName === 'hotels'
    const isFlightOrHotels = false
    if (!isFlightOrHotels) {
      setLoader(true)
      dispatch(getServiceBannersList())
    }
    setIsVideoDisabled(isFlightOrHotels)
  }, [router.asPath])

  useEffect(() => {
    if (serviceBannerVideoList?.length > 0) {
      const filteredBanners = serviceBannerVideoList?.filter(
        item => item.name === capitalizedPageName
      )
      if (filteredBanners?.length > 0) {
        // Transform data for easier access
        setBackgroundImagesTitle(filteredBanners[0].title);
        const transformedData = filteredBanners.reduce((acc, banner) => {
          acc[banner.name] = banner.src || [] // Ensure it's always an array
          return acc
        }, {})

        // Store in local storage
        localStorage.setItem(
          'bannerImageVideo',
          JSON.stringify(transformedData)
        )

        // Update state with transformed data
        setData(transformedData)
        setLoader(false)
      }
    }
  }, [serviceBannerVideoList, currentTab])

  useEffect(() => {
    if (data) {
      const storedBannerImage = localStorage.getItem('bannerImageVideo')

      if (storedBannerImage) {
        const bannerImageList = JSON.parse(storedBannerImage)
        setBannerLocalImage(prevState =>
          JSON.stringify(prevState) !== JSON.stringify(bannerImageList)
            ? bannerImageList
            : prevState
        )
      }
    }
  }, [data])

  useEffect(() => {
    if (currentTab && bannerLocalImage) {
      setBackgroundImages(bannerLocalImage[currentTab] ?? null)
    }
  }, [currentTab, bannerLocalImage])

  useEffect(() => {
    if (
      backgroundImages !== undefined &&
      backgroundImages !== null &&
      backgroundImages !== ''
    ) {
      // Check if the file is a video
      const videoFormats = ['.mp4', '.webm', '.ogg']
      const isVideoFile = videoFormats.some(format =>
        backgroundImages?.toLowerCase().endsWith(format)
      )
      setIsVideo(isVideoFile)
    }
  }, [backgroundImages])

  useEffect(() => {
    if (isVideo && videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error('Autoplay failed:', error)
      })
    }
  }, [isVideo, backgroundImages])

  if (!backgroundImages || isVideoDisabled || !backgroundImagesTitle) {
    return null
  }
  return loader ? (
    <div className='my-5'>
      <Skeleton variant='rectangular' width='100%' height={180} />
    </div>
  ) : (
    <div className='video-banner my-2'>
      {isVideo ? (
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className='video-background'
          key={backgroundImages}
        >
          <source
            src={`${process.env.IMAGE_BASE_URL}/${backgroundImages}`}
            type='video/mp4'
          />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          src={`${process.env.IMAGE_BASE_URL}/${backgroundImages}`}
          alt='Banner'
          className='image-background'
        />
      )}

      <div className='overlay'>
        <h1>{backgroundImagesTitle || ''}</h1>
      </div>
    </div>
  )
}

export default VideoBanner
